import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import Maps from './Maps';
import Leaderboard from './Leaderboard';
import PlayersTab from './tournament/PlayersTab';
import RulesTab from './tournament/RulesTab';

const LeaderboardTournamentView = ({ tournament, players, tournamentId }) => {
  return (
    <Tabs defaultValue="leaderboard" className="w-full">
      <TabsList className="w-full justify-start overflow-x-auto">
        <TabsTrigger value="leaderboard">Leaderboard</TabsTrigger>
        {!tournament.hideMaps && <TabsTrigger value="maps">Maps</TabsTrigger>}
        <TabsTrigger value="rules">Rules</TabsTrigger>
        <TabsTrigger value="players">Players</TabsTrigger>
      </TabsList>

      <TabsContent value="leaderboard">
        <Leaderboard tournamentId={tournamentId} />
      </TabsContent>

      {!tournament.hideMaps && (
        <TabsContent value="maps">
          <Maps tournamentId={tournamentId} />
        </TabsContent>
      )}

      <TabsContent value="rules">
        <RulesTab html={tournament.rules} />
      </TabsContent>

      <TabsContent value="players">
        <PlayersTab players={players} />
      </TabsContent>
    </Tabs>
  );
};

export default LeaderboardTournamentView;
